import { Dispatch } from 'react';

import { transformDateFormat } from 'susy-common/date-utils';

import { SuSyApi } from '../../api/susyApi';
import { PostDispatch } from '../types';
import * as actionType from './types';
import { SupervisorAction, SupervisorActionType } from './SupervisorActions';
import { AuthActionType } from '../actionTypes';
import { AuthAction } from './auth';

export * from './ProjectActions';
export * from './ProjectTimelineActions';
export * from './RubricActions';
export * from './GradingSchemaActions';
export * from './IntakeActions';
export * from './ResearchAreaActions';
export * from './ExtensionRequestActions';
export * from './UserActions';
export * from './UserRoleActions';
export * from './AdminActions';
export * from './auth';
export * from './PlagiarismCheckerActions';
export * from './ConfigAction';
export * from './gradingAction';
export * from './ImageActions';
export * from './billingActions';
export * from './settings/projectSettingsActions';
export * from './settings/generalAppSettingsActions';
export * from './EmailTemplateActions';
export * from './VersionAction';
export * from './MySupervisionsActions';
export * from './archive/ArchivedProjectActions';

export const getProjectOverview =
    (userId: string | null) => async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.get(
            `/project/${userId}/projectOverview`
        );
        dispatch({
            type: actionType.GET_PROJECT_OVERVIEW,
            payload: transformDateFormat(response.data),
        });
    };

export const getAdminDashboardData =
    () => async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.get(
            `/project-management/admin/dashboard`
        );
        dispatch({
            type: actionType.GET_ADMIN_DASHBOARD,
            payload: transformDateFormat(response.data),
        });
    };

export const getAllSupervisor =
    () => async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.get(`/user/supervisors/all`);
        dispatch({
            type: actionType.GET_ALL_SUPERVISOR,
            payload: response.data,
        });
    };

export const getAllSupervisorAdmin =
    () => async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.get(`/user/supervisors/all/admin`);
        dispatch({
            type: actionType.GET_ALL_SUPERVISOR,
            payload: response.data,
        });
    };

export const putSupervisorProjectsCapacity =
    (capacity: number, supervisorId: string) =>
    async (dispatch: Dispatch<SupervisorAction | AuthAction>) => {
        const response = await SuSyApi.put(
            `/user/supervisorCapacity/${supervisorId}`,
            { capacity }
        );

        dispatch({
            type: SupervisorActionType.PUT_SUPERVISOR_CAPACITY,
            payload: response.data,
        });

        dispatch({
            type: AuthActionType.SUPERVISOR_CAPACITY_UPDATE,
            payload: response.data,
        });
    };
